// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages90_root__2ASJT","title":"AfterImages90_title__-u4Xn","images":"AfterImages90_images__3DJ1H"};